var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition-group',{attrs:{"name":"slide-left","tag":"div"}},_vm._l((_vm.messages),function(message,index){return _c('div',{key:`nm-${index}`,class:[`alert-${message.type} alert`],attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(message.message)+" \n        ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }